import { render, staticRenderFns } from "./skip-to-content.vue?vue&type=template&id=68d946ca&scoped=true"
import script from "./skip-to-content.vue?vue&type=script&lang=js"
export * from "./skip-to-content.vue?vue&type=script&lang=js"
import style0 from "./skip-to-content.vue?vue&type=style&index=0&id=68d946ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d946ca",
  null
  
)

export default component.exports